import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseOrder } from 'src/app/models/purchase-order';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { PurchaseOrderLine } from 'src/app/models/purchase-order-line';
import { ToastrManager } from 'ng6-toastr-notifications';
import { AuthService } from 'src/app/services/auth.service';

export interface filter {id:number, name:string};

@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class PurchaseOrderComponent implements OnInit {
  filters = {
    byDates: 'dates',
    byOpen: 'open',
    order: 'open', 
    date1: new Date,
    date2: new Date,
  };
  orders:PurchaseOrder[] = [];
  ordersAll:PurchaseOrder[] = [];
  loading:boolean = false;

  suppliers:filter[] = [];
  supplier:filter = null;
  unities:filter[] = [];
  unity:filter = null;
  users:filter[] = [];
  user:filter = null;

  showFilters:boolean = false;

  constructor( private orderServ:PurchaseOrderService, private auth:AuthService, private toastr:ToastrManager ) { }

  ngOnInit() {
  }

  authorize(order:PurchaseOrder) {
    this.loading = true;
    this.orderServ.authorizeOrder(order).then(resp => {
      order.authorized = true;
      order.authorized_by = this.auth.getActualUser();
      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr("La orden no puede ser autorizada! tal vez se haya eliminado.");
      this.loading = false;
    });
  }

  search() {
    this.loading = true;
    if (this.filters.order == this.filters.byDates) {
      this.orderServ.getOrdersByDates(this.filters.date1, this.filters.date2).then(order => {
        this.orders = order;
        this.ordersAll = order;
        this.loading = false;
        this.showFilters = true;
        this.createFilters();
      });
    } else {
      this.orderServ.getOpenOrders().then(order => {
        this.orders = order;
        this.ordersAll = order;
        this.loading = false;
        this.showFilters = true;
        this.createFilters();
      });
    }
  }

  getTotal(lines:PurchaseOrderLine[]) {
    return lines.filter(ln => ln.status != 'Cancelado')
      .map(line => ((line.quantity * line.unit_price) - ((line.quantity * line.unit_price) * (line.discount / 100))) * (line.iva*1 + 1))
      .reduce((an, ac) => an + ac, 0);
  }

  filterData() {
    this.orders = this.ordersAll.filter(or => (this.supplier == null || or.supplier_id == this.supplier.id) && (this.user == null || or.user_id == this.user.id) && (this.unity == null || this.hasUnity(or.lines, this.unity.id)));
  }

  hasUnity(lines:PurchaseOrderLine[], unity:number) {
    return lines.find(u => u.unity_id == unity) ? true : false;
  }

  createFilters() {
    this.users = [];
    this.suppliers = [];
    this.unities = [];

    for (let i = 0; i < this.ordersAll.length; i++) {
      if (!this.users.find(u => u.name == `${this.ordersAll[i].user.name} ${this.ordersAll[i].user.last_name}`)) {
        this.users.push({
          id: this.ordersAll[i].user_id,
          name: `${this.ordersAll[i].user.name} ${this.ordersAll[i].user.last_name}`,
        });
      }
      if (!this.suppliers.find(s => s.name == this.ordersAll[i].supplier_name)) {
        this.suppliers.push({
          id: this.ordersAll[i].supplier_id,
          name: this.ordersAll[i].supplier_name,
        });
      }
      for (let j = 0; j < this.ordersAll[i].lines.length; j++) {
        if (this.ordersAll[i].lines[j].unity_id && !this.unities.find(u => u.id == this.ordersAll[i].lines[j].unity_id)) {
          this.unities.push({
            id: this.ordersAll[i].lines[j].unity_id,
            name: this.ordersAll[i].lines[j].unity_id + "",
          });
        }
      }
    }
  }

}
